import React, { useEffect, useState, useRef } from "react";
import { Form, FormGroup, Label, Input, Row, Col, Container } from "reactstrap";
import "./ReactQuills";
import "../Banner/banner.css";
import api from "../../Axios";
import NotificationAlert from "react-notification-alert";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import Swal from "sweetalert2";

const AddMembership = () => {
  const notiRef = useRef();
  const [data, setData] = useState({
    selectPlan: "regular",
    name: "gold",
    duration: "",
    period: "days",
    sendInterest: "",
    viewHoroscope: "",
    viewContactNos: "",
    chat: "",
    profileHighlighter: "",
    brokerService: "",
    regularPrimeChat: "",
    regularPrice: "",
    offerPrice: "",
    status: "active",
  });

  const [render, setRender] = useState(false);

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // Prevent negative numbers
    if (type === "number" && value < 0) return;

    setData((prevData) => {
      let updated = { ...prevData, [name]: value };

      // 👉 When selectPlan changes, update name automatically
      if (name === "selectPlan") {
        updated.name = value;
      }

      return updated;
    });
  };


  function handleSubmit(e) {
    e.preventDefault();

    const postingData = {
      ...data,
      duration: parseInt(data.duration) || 0,
      sendInterest: parseInt(data.sendInterest) || 0,
      viewHoroscope: parseInt(data.viewHoroscope) || 0,
      viewContactNos: parseInt(data.viewContactNos) || 0,
      chat: parseInt(data.chat) || 0,
      profileHighlighter: parseInt(data.profileHighlighter) || 0,
      brokerService: parseInt(data.brokerService) || 0,
      regularPrimeChat: parseInt(data.regularPrimeChat) || 0,
      regularPrice: parseInt(data.regularPrice) || 0,
      offerPrice: parseInt(data.offerPrice) || 0,
    };

    api.post("/admin/membership/addMembership", postingData).then((res) => {
      Swal.fire(res.data.data);
      setData({
        selectPlan: "",
        name: "",
        duration: "",
        period: "",
        sendInterest: "",
        viewHoroscope: "",
        viewContactNos: "",
        chat: "",
        profileHighlighter: "",
        brokerService: "",
        regularPrimeChat: "",
        regularPrice: "",
        offerPrice: "",
        status: "",
      });
    });
  }

  return (
    <div>
      <div className="content">
        <div className="notification-popup">
          <NotificationAlert ref={notiRef} />
        </div>
        <Row>
          <Col xs={12} md={12}>
            <div className="page-title">
              <div className="float-left">
                <h1 className="title">                    Add Membership Plan</h1>
              </div>
            </div>

            <div className="col-12">
              <section className="box ">


                <div className="content-body pt-1">
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-8">
                      <Form onSubmit={handleSubmit}>
                        <FormGroup>
                          <label>Select Plan</label>
                          <select
                            onChange={handleChange}
                            name="selectPlan"
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="regular">Regular</option>
                            <option value="prime">Prime</option>
                            <option value="elite">Elite</option>
                          </select>
                        </FormGroup>
                        {/* <FormGroup>
                          <Label>Name</Label>
                          <Input
                            type="select"
                            name="name"
                            onChange={handleChange}
                            value={data.name}
                          >
                            <option value="gold">Gold</option>
                            <option value="diamond">Diamond</option>
                            <option value="elite">Elite</option>
                          </Input>
                        </FormGroup> */}
                        <FormGroup>
                          <label>Period</label>
                          <select
                            onChange={handleChange}
                            name="period"
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="days">Day</option>
                            <option value="months">Month</option>
                            <option value="years">Year</option>
                          </select>
                        </FormGroup>
                        <FormGroup>
                          <Label>Duration</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="duration"
                            value={data.duration}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label> No of Sent Interest</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="sendInterest"
                            value={data.sendInterest}
                          />
                        </FormGroup>{" "}
                        <FormGroup>
                          <Label> No of View Horoscope</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="viewHoroscope"
                            value={data.viewHoroscope}
                          />
                        </FormGroup>{" "}
                        <FormGroup>
                          <Label> No of View Contact Number</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="viewContactNos"
                            value={data.viewContactNos}
                          />
                        </FormGroup>{" "}
                        <FormGroup>
                          <Label> No of chat</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="chat"
                            value={data.chat}
                          />
                        </FormGroup>{" "}
                        <FormGroup>
                          <Label>Profile Highlighter</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="profileHighlighter"
                            value={data.profileHighlighter}
                          />
                        </FormGroup>{" "}
                        <FormGroup>
                          <Label>Broker Service</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="brokerService"
                            value={data.brokerService}
                          />
                        </FormGroup>{" "}
                        <FormGroup>
                          <Label>Regular Prime Chat</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="regularPrimeChat"
                            value={data.regularPrimeChat}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label> Price</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="regularPrice"
                            value={data.regularPrice}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label> Offer Price</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name="offerPrice"
                            value={data.offerPrice}
                          />
                        </FormGroup>{" "}
                        <FormGroup>
                          <label>Status</label>
                          <select
                            onChange={handleChange}
                            name="status"
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                        </FormGroup>
                        <FormGroup style={{ marginBottom: "0px" }}>
                          <button
                            type="submit"
                            className="btn "
                            style={{
                              padding: "5px 10px",
                              background: "black",
                              color: "white",
                              fontWeight: "500",
                            }}
                          >
                            Submit
                          </button>
                        </FormGroup>
                      </Form>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AddMembership;
